export default __webpack_public_path__ + "img/thermometer.7e5365.svg";